import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"

import { DashboardWelcome } from "@/components/Dashboard"

export const Route: AnyRoute = createFileRoute("/app/dashboard")({
  component: () => <DashboardWelcome />,
})
